/**
 * 应用配置
 */

// WebSocket URL - 使用相对路径，自动适配当前协议和主机
// 浏览器会自动将 ws:// 升级为 wss:// (HTTPS)
export const API_BASE = ''; // 使用相对路径，由 nginx 或 Vite 代理处理
export const WS_URL = (window.location.protocol === 'https:' ? 'wss:' : 'ws:') + '//' + window.location.host + '/ws';

// 获取应用配置
export async function fetchAppConfig(): Promise<{ appName: string }> {
  const response = await fetch(`${API_BASE}/api/config`);
  return response.json();
}

// 消息历史配置
export const HISTORY_LIMIT = 200;
export const HISTORY_LOAD_MORE = 50;

// 上传配置
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];

// UI 配置
export const TYPING_INDICATOR_DELAY = 300;
export const SCROLL_THRESHOLD = 100; // 距离底部多少像素时自动滚动
export const RECONNECT_DELAY = 3000; // WebSocket 重连延迟

// 存储键名
export const STORAGE_KEYS = {
  TOKEN: 'nanoclaw_token',
  CHAT_JID: 'nanoclaw_chat_jid',
  THEME: 'nanoclaw_theme',
} as const;
